'use strict';

export default class LoginController {
  user = {
    name: '',
    email: '',
    password: ''
  };
  errors = {
    login: undefined
  };
  submitted = false;


  /*@ngInject*/
  constructor(Auth, $state, User) {
    this.Auth = Auth;
    this.$state = $state;
    this.User = User;
  }

  enter() {
    this.$state.go('home');
  }
}



// WEBPACK FOOTER //
// ./client/app/account/login/login.controller.js